export default __webpack_public_path__ + "static/media/hylylogo-white.53ea6d86.svg";